<div
  class="usf-pme-product-card"
  [class.selected-card]="isSelected"
  (click)="onProductClick()"
  data-cy="pme-product-card"
>
  <div
    class="pme-card-content flex column"
    [class.has-warning-drawer]="
      product?.drawerMsg?.isWarning ||
      (product?.productCardWarningMsg?.display && !product?.drawerMsg?.message)
    "
    [class.mobile-view]="screenWidth < 768"
  >
    <div *ngIf="product?.drawerMsg">
      <app-product-card-drawer
        [drawerMessage]="product?.drawerMsg"
        [warningMessage]="product?.productCardWarningMsg"
        (infoIconClickEmitter)="onInfoIconClick()"
        (bannerClickEmitter)="onBannerClick()"
      >
      </app-product-card-drawer>
    </div>
    <div class="pme-card-content-container">
      <div
        *ngIf="product?.easyPricingViewModel?.unifiedResponseCode !== 300"
        class="pme-card-upper-section"
      >
        <div
          class="product-info-container"
          data-cy="pme-product-info-container"
        >
          <div class="product-image">
            <app-product-card-image
              [isOnline]="isOnline"
              [imageThumbnail]="product?.imageThumbnail"
              [productNumber]="product?.productNumber"
              [height]="screenWidth < 1200 ? 3.5 : 5"
              [width]="screenWidth < 1200 ? 3.5 : 5"
              [clickable]="false"
            ></app-product-card-image>
          </div>

          <div class="pme-container">
            <div class="product-details" data-cy="pme-product-details">
              <app-product-card-information
                [brand]="product?.summary?.brand"
                [description]="product?.summary?.productDescTxtl"
                [note]="product?.item?.note"
                [productNumber]="product?.productNumber"
                [salesPackSize]="product?.summary?.salesPackSize"
                [showNote]="showNote"
                [notFound]="product?.notFound"
                [showPowerReview]="false"
                [pricePerPortion]="product?.pricePerPortion"
                [clickable]="false"
                [isGuestUser]="false"
                [smallDescriptionText]="screenWidth < 1200"
                [flexWrap]="false"
                (itemNoteClickEmitter)="itemNoteClicked()"
              >
              </app-product-card-information>
            </div>
            <ng-container *ngIf="screenWidth >= 1200">
              <ng-container *ngTemplateOutlet="pmeInfoWide"></ng-container>
            </ng-container>
          </div>
        </div>
        <ng-container *ngIf="screenWidth < 1200">
          <ng-container *ngTemplateOutlet="pmeInfoNarrow"></ng-container>
        </ng-container>
        <ng-container
          *ngIf="
            screenWidth < 768 && !!product?.promotionDetails?.offerBenefitDesc
          "
        >
          <div class="promotions-banner-container">
            <app-product-card-promotions-banner
              [productNumber]="product?.productNumber"
              [offerBenefitDesc]="product?.promotionDetails?.offerBenefitDesc"
              (bannerClickEmitter)="onBannerClick()"
            ></app-product-card-promotions-banner>
          </div>
        </ng-container>

        <!-- right column -->
        <div
          *ngIf="product?.easyPricingViewModel?.unifiedResponseCode !== 300"
          class="pricing-info"
        >
          <div class="current-week-wrapper">
            <div class="value" data-cy="pme-current-week-label">
              {{ 'i18n.lists.pmeList.currentWeek' | translate }}
            </div>
            <div class="calculations-container">
              <div
                class="value current-price"
                *ngIf="!product?.easyPricingViewModel?.isReloading"
                data-cy="pme-current-week-value"
              >
                {{
                  product?.easyPricingViewModel?.currentUnitPrice
                    ? (product?.easyPricingViewModel?.currentUnitPrice
                      | currency)
                    : 'N/A'
                }}
              </div>
              <ion-spinner
                *ngIf="product?.easyPricingViewModel?.isReloading"
                name="circles"
                data-cy="pme-current-week-spinner"
              ></ion-spinner>
              <div
                *ngIf="
                  product?.easyPricingViewModel?.currentWeekDifference &&
                  !product?.easyPricingViewModel?.isReloading
                "
                class="price-change-value"
                [class.negative]="
                  product?.easyPricingViewModel?.currentWeekDifference < 0
                "
                data-cy="pme-price-change"
              >
                <span data-cy="pme-current-week-difference-value">
                  {{
                    product?.easyPricingViewModel?.currentWeekDifference
                      | currency
                  }}
                </span>
                <img
                  *ngIf="product?.easyPricingViewModel?.currentWeekDifference"
                  [src]="
                    product?.easyPricingViewModel?.currentWeekDifference > 0
                      ? 'assets/icon/up-arrow.svg'
                      : 'assets/icon/down-arrow.svg'
                  "
                  [alt]="
                    product?.easyPricingViewModel?.currentWeekDifference > 0
                      ? 'arrow-up'
                      : 'arrow-down'
                  "
                  data-cy="pme-current-week-difference-icon"
                />
              </div>
            </div>
          </div>

          <div class="target-case-price-wrapper">
            <div class="value" data-cy="pme-target-case-price-label">
              {{ 'i18n.lists.pmeList.targetCasePrice' | translate }}
            </div>
            <div
              class="target-case-price-container"
              [class.selected]="
                product?.easyPricingViewModel?.isSuccess &&
                !product?.easyPricingViewModel?.isCustomUpdate
              "
              [class.disabled]="
                !product?.easyPricingViewModel?.isCprEnabled ||
                product?.easyPricingViewModel?.isProcessing
              "
              [class.error]="
                product?.easyPricingViewModel?.isError &&
                !product?.easyPricingViewModel?.isCustomUpdate
              "
              (click)="selectTargetPrice($event)"
            >
              <img
                *ngIf="
                  product?.easyPricingViewModel?.isSuccess &&
                  !product?.easyPricingViewModel?.isCustomUpdate
                "
                src="assets/icon/checkmark-fill-green.svg"
                alt="checkmark"
                data-cy="pme-target-case-price-checkmark"
              />
              <ion-spinner
                *ngIf="
                  product?.easyPricingViewModel?.isProcessing &&
                  !product?.easyPricingViewModel?.isCustomUpdate
                "
                name="circles"
                data-cy="pme-target-case-price-spinner"
              ></ion-spinner>
              <div
                class="target-case-price medium-font-weight"
                [class.selected]="
                  product?.easyPricingViewModel?.isSuccess &&
                  !product?.easyPricingViewModel?.isCustomUpdate
                "
                [class.gray-text]="
                  !product?.easyPricingViewModel?.isCprEnabled ||
                  product?.easyPricingViewModel?.isProcessing
                "
                [class.error]="
                  product?.easyPricingViewModel?.isError &&
                  !product?.easyPricingViewModel?.isCustomUpdate
                "
                data-cy="pme-target-case-price-value"
              >
                {{
                  product?.easyPricingViewModel?.targetCasePrice
                    ? (product?.easyPricingViewModel?.targetCasePrice
                      | currency)
                    : '$0.00'
                }}
              </div>
            </div>
          </div>
          <div>
            <div
              class="custom-case-price-wrapper"
              data-cy="pme-custom-case-price-wrapper"
            >
              <div class="value" data-cy="pme-custom-case-price-label">
                {{ 'i18n.lists.pmeList.customCasePrice' | translate }}
              </div>
              <div class="price-change-container-wrapper">
                <ion-input
                  id="cs-{{ product?.listId }}-{{ index }}"
                  class="custom-price-input"
                  globalkeyhandler="quantityInput"
                  [class.accepted]="
                    product?.easyPricingViewModel?.priceStatus?.cssClass ===
                    'accepted'
                  "
                  [class.denied]="
                    product?.easyPricingViewModel?.priceStatus?.cssClass ===
                    'denied'
                  "
                  [class.failed]="
                    product?.easyPricingViewModel?.priceStatus?.cssClass ===
                    'failed'
                  "
                  [class.processing]="
                    product?.easyPricingViewModel?.priceStatus?.cssClass ===
                    'processing'
                  "
                  [class.disabled]="
                    !product?.easyPricingViewModel?.isCprEnabled ||
                    product?.easyPricingViewModel?.isProcessing
                  "
                  [disabled]="
                    !product?.easyPricingViewModel?.isCprEnabled ||
                    product?.easyPricingViewModel?.isProcessing
                  "
                  inputmode="decimal"
                  placeholder="$0.00"
                  data-cy="pme-custom-price-input"
                  [maxPrecision]="2"
                  customDecimal
                  [value]="
                    product?.easyPricingViewModel?.customPrice | currency
                  "
                  (ionBlur)="onCustomPriceChange($event)"
                  (click)="onCustomPriceClick($event)"
                ></ion-input>
              </div>
            </div>
            <div
              class="price-change-status-wrapper"
              data-cy="pme-price-change-status-wrapper"
            >
              <div class="placeholder"></div>
              <div
                class="price-change-status medium-font-weight"
                [class]="
                  product?.easyPricingViewModel?.priceStatus?.cssClass || ''
                "
                data-cy="pme-price-change-status-value"
              >
                <img
                  *ngIf="
                    product?.easyPricingViewModel?.priceStatus?.status ===
                      'ACCEPTED' ||
                    product?.easyPricingViewModel?.priceStatus?.status ===
                      'APPROVED'
                  "
                  src="assets/icon/checkmark-fill-green.svg"
                  alt="checkmark"
                  class="checkmark-icon"
                  data-cy="pme-price-change-status-accepted-icon"
                />
                <ion-icon
                  *ngIf="product?.easyPricingViewModel?.priceStatus?.showInfo"
                  name="information-circle-outline"
                  class="info-icon"
                  (click)="openPopover($event)"
                  data-cy="pme-price-change-status-info-icon"
                ></ion-icon>
                <span
                  *ngIf="product?.easyPricingViewModel?.priceStatus?.status"
                  >{{
                    'i18n.lists.pmeList.' +
                      product?.easyPricingViewModel?.priceStatus?.status?.toLowerCase()
                      | translate
                  }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <ng-container
        *ngIf="product?.easyPricingViewModel?.unifiedResponseCode === 300"
      >
        <ng-container *ngTemplateOutlet="manualApproval"></ng-container>
      </ng-container>
      <div
        *ngIf="product?.productTags?.length > 0"
        class="product-tags-under-image"
      >
        <app-usf-product-tag-list
          [tagList]="product?.productTags"
          [infoIconEnabled]="false"
          [allTagsClickable]="false"
          [maxTags]="screenWidth >= 1200 ? 6 : screenWidth >= 768 ? 4 : 2"
        ></app-usf-product-tag-list>
      </div>
    </div>
  </div>

  <ion-popover
    class="pme-price-change-status-popover"
    #popover
    mode="ios"
    arrow="true"
    side="bottom"
    alignment="center"
    [isOpen]="isPopoverOpen"
    data-cy="pme-price-change-popover"
    (didDismiss)="isPopoverOpen = false"
  >
    <ng-template>
      <ion-content class="ion-padding">
        <p data-cy="pme-price-change-popover-message">
          {{
            'i18n.lists.pmeList.' +
              product?.easyPricingViewModel?.priceStatus?.tooltip | translate
          }}
        </p>
      </ion-content>
    </ng-template>
  </ion-popover>

  <ng-template #pmeInfoWide>
    <div class="pme-info-prices">
      <div class="info-item">
        <span class="label" data-cy="pme-last-week-label"
          >{{ 'i18n.lists.pmeList.lastWeek' | translate }}&nbsp;</span
        >
        <span class="value" data-cy="pme-last-week-value">
          {{
            product?.easyPricingViewModel?.lastUnitPrice
              ? (product?.easyPricingViewModel?.lastUnitPrice | currency)
              : 'N/A'
          }}
        </span>
      </div>
      <div class="info-item">
        <span class="label" data-cy="pme-low-limit-label"
          >{{ 'i18n.lists.pmeList.lowLimit' | translate }}&nbsp;</span
        >
        <span class="value" data-cy="pme-low-limit-value">
          {{
            product?.easyPricingViewModel?.lowLimit
              ? (product?.easyPricingViewModel?.lowLimit | currency)
              : 'N/A'
          }}
        </span>
      </div>
    </div>
    <div class="pme-info-column">
      <div class="info-item">
        <span class="label" data-cy="pme-wwp-label"
          >{{ 'i18n.lists.pmeList.wwp' | translate }}&nbsp;</span
        >
        <span class="value" data-cy="pme-wwp-value">
          {{ product?.easyPricingViewModel?.wwp || 'N/A' }}
        </span>
      </div>
      <div class="info-item">
        <span class="label" data-cy="pme-rationale-label"
          >{{ 'i18n.lists.pmeList.rationale' | translate }}&nbsp;</span
        >
        <span class="value" data-cy="pme-rationale-value">
          {{ product?.easyPricingViewModel?.rationale || 'N/A' }}
        </span>
      </div>
      <div class="info-item">
        <span class="label" data-cy="pme-target-difference-label"
          >{{ 'i18n.lists.pmeList.targetDifference' | translate }}&nbsp;</span
        >
        <span class="value" data-cy="pme-target-difference-value">
          {{
            product?.easyPricingViewModel?.targetDifference
              ? (product?.easyPricingViewModel?.targetDifference | currency)
              : 'N/A'
          }}
        </span>
      </div>
    </div>
  </ng-template>

  <ng-template #pmeInfoNarrow>
    <div class="pme-info-container">
      <div class="pme-info-column">
        <div class="info-item">
          <span class="label" data-cy="pme-last-week-label"
            >{{ 'i18n.lists.pmeList.lastWeek' | translate }}&nbsp;</span
          >
          <span class="value" data-cy="pme-last-week-value">
            {{
              product?.easyPricingViewModel?.lastUnitPrice
                ? (product?.easyPricingViewModel?.lastUnitPrice | currency)
                : 'N/A'
            }}
          </span>
        </div>
        <div class="info-item">
          <span class="label" data-cy="pme-low-limit-label"
            >{{ 'i18n.lists.pmeList.lowLimit' | translate }}&nbsp;</span
          >
          <span class="value" data-cy="pme-low-limit-value">
            {{
              product?.easyPricingViewModel?.lowLimit
                ? (product?.easyPricingViewModel?.lowLimit | currency)
                : 'N/A'
            }}
          </span>
        </div>
      </div>
      <div class="pme-info-column">
        <div class="info-item">
          <span class="label" data-cy="pme-wwp-label"
            >{{ 'i18n.lists.pmeList.wwp' | translate }}&nbsp;</span
          >
          <span class="value" data-cy="pme-wwp-value">
            {{ product?.easyPricingViewModel?.wwp || 'N/A' }}
          </span>
        </div>
        <div class="info-item">
          <span class="label" data-cy="pme-rationale-label"
            >{{ 'i18n.lists.pmeList.rationale' | translate }}&nbsp;</span
          >
          <span class="value" data-cy="pme-rationale-value">
            {{ product?.easyPricingViewModel?.rationale || 'N/A' }}
          </span>
        </div>
      </div>
      <div class="pme-info-column">
        <div class="info-item">
          <span class="label" data-cy="pme-target-difference-label"
            >{{ 'i18n.lists.pmeList.targetDifference' | translate }}&nbsp;</span
          >
          <span class="value" data-cy="pme-target-difference-value">
            {{
              product?.easyPricingViewModel?.targetDifference
                ? (product?.easyPricingViewModel?.targetDifference | currency)
                : 'N/A'
            }}
          </span>
        </div>
        <div class="info-item"></div>
      </div>
    </div>
  </ng-template>
</div>

<ng-template #manualApproval>
  <app-manual-approval
    [product]="product"
    [isOnline]="isOnline"
    [screenWidth]="screenWidth"
    [isTouch]="isTouch"
    (closeManualApproval)="onCloseManualApproval()"
    (manualApprovalSubmit)="onManualApprovalSubmit($event)"
    (reasonSelected)="onReasonSelected($event)"
    #manualApprovalComponent
  ></app-manual-approval>
</ng-template>
